<template :user="user">
    <div class="table-responsive">
        <table class="table table-valign-middle mb-0">
            <thead>
                <tr>
                    <th class="th-fit"></th>
                    <th>Name</th>
                    <th>Owner/Team</th>
                    <th>created</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="task in tasks.data" :key="task.id">
                    <td>
                       <a  :href="'/task/'+task.id"> <img
                            :src="'/file/thumbnail/' + task.main_image.id"
                            alt="image"
                            class="spark-profile-photo"
                        /></a>

                      
                    


                    </td>
                    <td>

                          <a :href="'/task/'+task.id">   {{ task.name }} </a>
                          
                    </td>

                    <td>
                        <div>
                            <span>
                                {{ task.user.name }} 
                            </span>
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ task.created_date }}
                        </div>
                    </td>
                    <td class="td-fit">
                        <div 
                            v-show="task.state == 0"
                            class="spinner-border spinner-border-sm"
                            role="status"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>


                            <i v-show="task.state == 9" class="fa fa-check text-success"></i>
                            <i data-toggle="tooltip" data-placement="top" :title="task.error"
                                v-show="task.state == 8"
                                class="fa fa-exclamation text-danger"
                            ></i>


                    </td>
                </tr>
            </tbody>
        </table>
        <div class="mx-auto" style="width:200px">
            <pagination
                class="mx-auto"
                :data="tasks"
                @pagination-change-page="getTasks"
            ></pagination>
        </div>
    </div>
</template>

<script>
//require("../bootstrap.js");
//Vue.component("pagination", require("laravel-vue-pagination"));
import pagination from "laravel-vue-pagination";
export default {
    props: ["scope", "pagination", "taskcount", "user"],
    data: function() {
        return {
            tasks: {}
        };
    },
    components: {
        pagination
    },

    channel: "blog",
    echo: {
        BlogPostCreated: (payload, vm) => {
            console.log("blog post created", payload);
        },
        BlogPostDeleted: (payload, vm) => {
            console.log("blog post deleted", payload);
        }
    },
    mounted() {
        const vm = this;
        this.getTasks();

        window.Echo.private("users." + this.user.id).listen(
            ".task-changed",
            e => {
                console.log("e:" + e);
                this.getTasks();
            }
        );
    },
    methods: {
        getTasks(page = 1) {
            var pagination =
                this.pagination == "true" || this.pagination == true
                    ? true
                    : false;
            axios
                .get("/tasks?page=" + page, {
                    params: {
                        scope: this.scope,
                        pagination: pagination,
                        taskcount: this.taskcount
                    }
                })
                .then(response => {
                    this.tasks = response.data;
                    console.log(JSON.stringify(response));

                    this.tasks.forEach(element => {
                        // console.log(element.id);
                    });
                });
        },
        async getThumbnail(id) {
            axios.get("/file/thumbnail/" + id, {}).then(response => {
                console.log(JSON.stringify(response));
                return require(response);
            });
        }
    }
};
</script>
